var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"self-apply-modal\" class=\"popup popup-signature\"><div ng-style=\"{'background': $root.THEME_COLOR}\" class=\"head\"><h2>Notice</h2><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><p>Looks like you're logged in as {{user.email}} and applying to {{HOST}}/{{app_or_application_template.slug}}. Please note that this will submit the application to yourself.</p><a href=\"#\" ng-click=\"$dismiss()\" class=\"button\">Continue anyway</a></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/applications/apply/SelfApplyModal.jade
// module id = 1078
// module chunks = 0